import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Snackbar,
  Alert,
  Tabs,
  Tab
} from '@mui/material';
import axios from 'axios';

const API_URL = 'https://pdks.bytebridge.com.tr/api/health-safety';

const HealthSafety = () => {
  const [incidents, setIncidents] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    severity: 'low',
    status: 'open'
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    fetchIncidents();
  }, []);

  const fetchIncidents = async () => {
    try {
      const response = await axios.get(API_URL);
      console.log('API Response:', response.data);
      
      // Backend verilerini frontend formatına uygun şekilde map'le
      const mappedData = {
        incidents: response.data.workAccidents || [],
        safetyTrainings: response.data.safetyTrainings || [],
        riskAssessments: response.data.riskAssessments || [],
        statistics: response.data.statistics || {}
      };
      
      setIncidents(mappedData);
    } catch (error) {
      console.error('API Error:', error);
      showSnackbar('Veriler yüklenirken hata oluştu', 'error');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(API_URL, formData);
      showSnackbar('Kayıt başarıyla eklendi', 'success');
      setOpenDialog(false);
      fetchIncidents();
      setFormData({ title: '', description: '', severity: 'low', status: 'open' });
    } catch (error) {
      showSnackbar('Kayıt eklenirken hata oluştu', 'error');
    }
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">İş Sağlığı ve Güvenliği</Typography>
        <Button 
          variant="contained" 
          color="primary"
          onClick={() => setOpenDialog(true)}
        >
          Yeni Kayıt Ekle
        </Button>
      </Box>

      <Paper sx={{ width: '100%', mb: 2 }}>
        <Tabs value={currentTab} onChange={(e, newValue) => setCurrentTab(newValue)}>
          <Tab label="Açık Kayıtlar" />
          <Tab label="Tüm Kayıtlar" />
        </Tabs>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Başlık</TableCell>
                <TableCell>Açıklama</TableCell>
                <TableCell>Öncelik</TableCell>
                <TableCell>Durum</TableCell>
                <TableCell>Oluşturulma Tarihi</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {incidents.incidents && incidents.incidents.filter && incidents.incidents.filter(incident => currentTab === 0 ? incident.status === 'open' : true).map((incident) => (
                  <TableRow key={incident.ID}>
                    <TableCell>{incident.Description}</TableCell>
                    <TableCell>{incident.Location}</TableCell>
                    <TableCell>{incident.AccidentDate}</TableCell>
                    <TableCell>{incident.EmployeeID}</TableCell>
                    <TableCell>{new Date(incident.AccidentDate).toLocaleDateString('tr-TR')}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <form onSubmit={handleSubmit}>
          <DialogTitle>Yeni İş Güvenliği Kaydı</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              name="title"
              label="Başlık"
              type="text"
              fullWidth
              variant="outlined"
              value={formData.title}
              onChange={handleInputChange}
              required
            />
            <TextField
              margin="dense"
              name="description"
              label="Açıklama"
              type="text"
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              value={formData.description}
              onChange={handleInputChange}
              required
            />
            <TextField
              select
              margin="dense"
              name="severity"
              label="Öncelik"
              fullWidth
              variant="outlined"
              value={formData.severity}
              onChange={handleInputChange}
              SelectProps={{
                native: true,
              }}
            >
              <option value="low">Düşük</option>
              <option value="medium">Orta</option>
              <option value="high">Yüksek</option>
              <option value="critical">Kritik</option>
            </TextField>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)}>İptal</Button>
            <Button type="submit" variant="contained" color="primary">
              Kaydet
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default HealthSafety;
